// Interprète le résultat d'une suppression Supabase (delete().select()).
// Règle de sécurité : ne JAMAIS considérer une suppression de 0 ligne comme un
// succès. Avec RLS activé, Supabase renvoie un résultat sans erreur même si la
// policy (ou un filtre user_id) a empêché toute suppression — la requête réussit
// mais ne supprime rien. Il faut donc vérifier le nombre réel de lignes renvoyées.
export function interpretDeleteResult({ error, data } = {}) {
  if (error) {
    return { ok: false, message: 'Suppression impossible: ' + error.message };
  }
  const rows = Array.isArray(data) ? data.length : data ? 1 : 0;
  if (rows === 0) {
    return {
      ok: false,
      message: tr("Suppression impossible: analyse introuvable ou action non autorisée.", 'Delete failed: analysis not found or action not allowed.')
    };
  }
  return { ok: true, message: tr('Analyse supprimée.', 'Analysis deleted.') };
}
import { tr } from '../services/i18n.js';
